import React, { useState } from 'react';
import './Footer.css';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { IconButton, Button } from '@mui/material';

function Footer() {
    const [newsletterEmail, setNewsletterEmail] = useState('');

    const handleNewsletterSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('/api/subscribe-newsletter', { // Updated endpoint
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: newsletterEmail }),
            });

            if (response.ok) {
                console.log('Successfully subscribed to the newsletter!');
                alert('Thank you for subscribing to our newsletter!');
                setNewsletterEmail('');
            } else {
                const errorData = await response.json();
                console.error('Failed to subscribe:', errorData.message);
                alert('Failed to subscribe to the newsletter or already subscribed. Please try again.');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred. Please try again.');
        }
    };

    return (
        <div className='footer-container'>
            {/* Newsletter Signup Section */}
            <div className="newsletter-container" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '10px', margin: '20px auto', maxWidth: '80%' }}>
                <h2 style={{ fontSize: '26px' }}>Sign Up for Our Newsletter</h2>
                <p>Stay updated with the latest news and offers from Fritz Physical Therapy.</p>
                <form onSubmit={handleNewsletterSubmit}>
                    <input
                        type="email"
                        name="newsletterEmail"
                        placeholder="Enter your email"
                        value={newsletterEmail}
                        onChange={(e) => setNewsletterEmail(e.target.value)}
                        style={{ padding: '10px', fontSize: '16px', borderRadius: '5px', border: '1px solid #ccc', width: '80%', maxWidth: '400px' }}
                        required
                    />
                    <Button
                        variant="contained"
                        size="medium"
                        type="submit"
                        style={{ marginLeft: '10px', padding: '10px 20px', fontSize: '16px', borderRadius: '5px' }}
                        sx={{ backgroundColor: '#883001', '&:hover': { backgroundColor: '#5B1F00' } }}
                    >
                        Subscribe
                    </Button>
                </form>
            </div>

            <div className='footer' style={{ display: 'flex', justifyContent: 'center', width: '100%', gap: '50%' }}>
                <div className='footer-right' style={{ textAlign: 'right', color: 'white', paddingTop: '5px' }}>
                    <div>
                        <p style={{ fontWeight: 'bold', display: 'inline' }}>Phone:</p>
                        <p style={{ display: 'inline' }}> 412-278-1221</p>
                    </div>
                    <div>
                        <br/><p style={{ fontWeight: 'bold', display: 'inline' }}>Fax:</p>
                        <p style={{ display: 'inline' }}> 412-278-0201</p>
                    </div>
                    <div style={{ marginTop: '10px' }}>
                        <a href="https://www.facebook.com/FritzPhysicalTherapAndSportsMedicne" target='_blank' rel='noopener noreferrer'>
                            <IconButton style={{ display: 'inline', color: 'white' }}>
                                <FacebookIcon sx={{ fontSize: '30px' }}/>
                            </IconButton>
                        </a>
                        <IconButton style={{ display: 'inline', color: 'white' }}>
                            <XIcon sx={{ fontSize: '28px' }}/>
                        </IconButton>
                        <a href="https://www.linkedin.com/company/fritz-physical-therapy/" target='_blank' rel='noopener noreferrer'>
                            <IconButton style={{ display: 'inline', color: 'white' }}>
                                <LinkedInIcon sx={{ fontSize: '30px' }}/>
                            </IconButton>
                        </a>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Fritz Physical Therapy, All Rights Reserved</p>
            </div>
        </div>
    );
}

export default Footer;